import Colors from 'constants/Colors';

export default {
  tableContainer: {
    backgroundColor: 'white',
    marginLeft: 32,
    marginRight: 32,
    width: '100%',
    borderRadius: 14,
    padding: 14,
    minHeight: '70vh',
    marginBottom: 32,
  },
  totalContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  statusIndicator: {
    borderRadius: 32,
    height: 18,
    width: 18,
  },
  statusSelector: {
    width: '100%',
    padding: '8px 0px',
    borderRadius: '8px',
    border: '1px solid #F8F8F8',
    backgroundColor: '#F8F8F8',
    fontSize: '14px',
    textAlign: 'center',
    cursor: 'pointer',
  },
  layoutContainer: {
    display: 'flex',
    width: '100%',
    flex: 1,
    marginTop: 16,
  },
  mainContainer: {
    width: '100%',
    paddingRight: 32,
    paddingLeft: 32,
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '24px',
    justifyContent: 'flex-end',
    width: '100%',
  },
  modalFields: {
    top: 'auto',
    bottom: -214,
  },
  textContainerFields: {
    display: 'flex',
    marginLeft: '90px',
    marginTop: '40px',
  },
  iconFields: {
    backgroundColor: Colors.grayBackground,
    borderRadius: '50%',
    width: '48px',
    height: '48px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '12px',
  },
  titleFields: {
    fontSize: '20px',
    marginBottom: '12px',
  },
  textFields: {
    marginBottom: '20px',
    fontSize: '14px',
    color: '#333',
  },
  fieldsTable: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  saveFieldsButton: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'center',
  },
};
